import { NgModule } from '@angular/core';
import { TooltipDirective } from './tooltip';

@NgModule({
   declarations: [TooltipDirective],
   exports: [TooltipDirective],
})
export class TooltipModule {}
